import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import React, { useContext, useEffect, useMemo, useState } from "react";
import ModalDommus from "../../components/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ItemBarraTitulo from "../../components/DommusBarraTitulo/ItemBarraTitulo";
import { Container } from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import DommusBarraTitulo from "../../components/DommusBarraTitulo";
import {DommusTabs} from "../../components/DommusTabs";
import { QuestionariosSection } from "./QuestionariosSection";
import { PergutasSection } from "./PerguntasSection";
import { PerguntaForm } from "./PerguntasSection/PerguntaForm";
import { QuestionarioForm } from "./QuestionariosSection/QuestionarioForm";
import { PerguntaContext } from "../../contexts/PerguntaContext";
import PerguntaService from "../../services/PerguntaService";
import { cachearContexto } from '../../helpers/CachearContexto';
import { QuestionarioContext } from "../../contexts/QuestionarioContext";
import QuestionarioService from "../../services/QuestionarioService";
import "./index.css";

export default function Questionarios(){
    const [selectedKey, setSelectedKey] = useState(0);
    const { listaQuestionarios, setListaQuestionarios } = useContext(QuestionarioContext);
    const { listaPerguntas, setListaPerguntas, listaTipoRespostaPerguntas, setListaTipoRespostaPerguntas } = useContext(PerguntaContext);
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        cachearContexto(listaTipoRespostaPerguntas, setListaTipoRespostaPerguntas, PerguntaService.buscarTipoResposta);
        cachearContexto(listaPerguntas, setListaPerguntas, PerguntaService.buscar);
        cachearContexto(listaQuestionarios, setListaQuestionarios, QuestionarioService.buscar);
    }, [])

    const tabsSections = useMemo(() => {
        return (
            [{
                id: 1,
                title: "Questionários",
                content: <QuestionariosSection />
            },
            {
                id: 2,
                title: "Perguntas",
                content: <PergutasSection />
            }
            ]
        )
    }, [])

    return (
        <>
            <ReactTooltip />
            <Container fluid>
                <DommusBarraTitulo>
                    <ItemBarraTitulo classe="">
                        Questionários
                    </ItemBarraTitulo>
                    <ItemBarraTitulo
                        classe="btn"
                        onClick={() => {
                            setOpenModal(true)
                        }}
                        data-tip={`Cadastrar ${selectedKey === 0 ? 'novo questionário' : 'nova pergunta'}`}
                    >
                        <FontAwesomeIcon icon={faPlusCircle} color="#4caf50" />
                    </ItemBarraTitulo>
                </DommusBarraTitulo>
                <section className="questionarios-section">
                    <DommusTabs tabs={tabsSections} getActiveTabIndex={(index) => { setSelectedKey(index) }} goToTab={0} />
                </section>
            </Container>

            <ModalDommus
                open={openModal}
                close={() => setOpenModal(false)}
                titulo={`Cadastrar ${selectedKey === 0 ? 'novo questionário' : 'nova pergunta'}`}
            >
              {
                selectedKey === 0 ?
                  <QuestionarioForm questionario={{}} closeModal={() => { setOpenModal(false) }} />
                  : <PerguntaForm pergunta={{}} closeModal={() => { setOpenModal(false) }} />
              }

            </ModalDommus>
        </>
    )
}
